import { SortOptionType } from "@/lib/Types/InspirationSortFilter";
import { WhitelabelConfig } from "@/whitelabel/helpers/types";

export const getHotelListSortOptions = (
  WlConfig: WhitelabelConfig
): SortOptionType[] => [
  {
    label: "Beliebtheit",
    value: "relevance",
    link: WlConfig.legalLinks.relevanceSortOrder.url,
  },
  {
    label: "Preis (niedrigster Preis)",
    value: "price",
  },
  {
    label: "Hotelkategorie",
    value: "stars",
  },
  {
    label: "Weiterempfehlungsrate",
    value: "recommendation",
  },
];

export const destinationListAllSortByOptions: SortOptionType[] = [
  {
    label: "Reiseziel (A ➙ Z)",
    value: "name",
  },
  {
    label: "Wärmstes Reiseziel",
    value: "climate",
  },
  {
    label: "Kürzeste Flugzeit",
    value: "flightduration",
  },
  {
    label: "Niedrigster Preis",
    value: "price",
  },
];

export const hotelDetailSortByOptions: SortOptionType[] = [
  {
    label: "Frühestes Hinreisedatum",
    value: "DATE",
  },
  {
    label: "Kürzeste Reisedauer",
    value: "DURATION",
  },
  {
    label: "Abflughafen (A ➙ Z)",
    value: "AIRPORT",
  },
  {
    label: "Niedrigster Preis",
    value: "PRICE",
  },
];

// Sort validation constants for middleware
export const VALID_HOTEL_DETAIL_SORT_VALUES = ["DATE", "DURATION", "AIRPORT", "PRICE"] as const;
export const VALID_HOTEL_LIST_SORT_VALUES = ["relevance", "price", "stars", "recommendation"] as const;
export const VALID_DESTINATION_LIST_SORT_VALUES = ["name", "climate", "flightduration", "price"] as const;
